import React, { Component } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { EventContainer } from './FormSteps/Event'
import { MoreContainer } from './FormSteps/More'
import { FormContainer } from '../Form'
import {
    isEmptyString,
} from '../../../../../../helpers/sanityChecks'
import {
    isDateValid,
    validateFields,
} from '../../../../../../helpers/collaborativeIndexations'
import Identity from './FormSteps/Identity.jsx'

class FrenchCivilRegistryForm extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.formSteps = [
            Identity,
            EventContainer,
            MoreContainer,
        ]

        this.formStepsValidation = {
            2: () => {
                validateFields({
                    lastname: () => ! isEmptyString(this.props.fields.lastname),
                    age: () => {
                        const age = this.props.fields.age;
                        const ageAsInt = Number.parseInt(age);

                        return age === null || (age === ageAsInt.toString() && ageAsInt >= 0 && ageAsInt <= 199)
                    }
                })
            },
            3: () => {
                validateFields({
                    eventDate: () => this.props.fields.eventDate === null || isDateValid(this.props.fields.eventDate),
                })
            }
        }
    }

    render()
    {
        return (
            <FormContainer steps={ this.formSteps } stepsValidation={ this.formStepsValidation } />
        )
    }
}

export default withTranslation()(FrenchCivilRegistryForm)
